import { render, staticRenderFns } from "./BannersCarousel.vue?vue&type=template&id=904c7ee4&scoped=true"
import script from "./BannersCarousel.vue?vue&type=script&lang=js"
export * from "./BannersCarousel.vue?vue&type=script&lang=js"
import style0 from "./BannersCarousel.vue?vue&type=style&index=0&id=904c7ee4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "904c7ee4",
  null
  
)

export default component.exports